export default {"src":"/_next/static/media/flag-en.fe8cc281.svg","height":3900,"width":7410,"blurWidth":0,"blurHeight":0};